import React from "react";
import { Card, Form, Input, Button } from "antd";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { special_characters_regexp } from "helpers/regexp";
import { useAuth } from "context/providers/auth";

const MainPageIntro = () => {
  const {
    state: {
      user: { company: data },
    },
    updateCompany,
  } = useAuth();

  const [form] = Form.useForm();
  const { pristine, has_error, onFieldsChange, reset } = useFormErrors(data);

  const path = "/companies";

  const { is_saving, create } = useCreate({
    path,
    form,
    success_message: "Zaktualizowano dane firmy",
    onSuccess: (company_data) => {
      updateCompany(company_data);
      reset();
    },
  });

  return (
    <Card className="m-b-20" title="Edytuj intro strony głównej formularza publicznego">
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={onFieldsChange}
        initialValues={{
          main_page_intro: data?.main_page_intro,
        }}
        onFinish={(values) => create(values)}
      >
        <Form.Item
          name="main_page_intro"
          required
          hasFeedback
          rules={[
            {
              required: true,
              message: "Pole wymagane",
            },
            {
              pattern: special_characters_regexp,
              message: "Niepoprawny tekst",
            },
          ]}
        >
          <Input placeholder="Intro" maxLength={128} showCount />
        </Form.Item>
        <Button
          disabled={pristine || has_error}
          loading={is_saving}
          type="primary"
          htmlType="submit"
        >
          Zapisz
        </Button>
      </Form>
    </Card>
  );
};

export default MainPageIntro;
